<template>
  <div>
    <base-card>
      <div class="tw-flex tw-justify-between">
        <h3 class="tw-text-xl tw-font-thin tw-mb-0">Payment History</h3>
        <base-button size="sm" @click="$refs.businessPaymentModal.show()">
          <template v-slot:icon>
            <plus-icon />
          </template>
          One Time Payment
        </base-button>
      </div>
      <base-table loading :fields="fields" class="tw-mt-3" v-if="isLoading">
        <template #loading-cell>
          <base-skeleton-loader class="tw-h-3 tw-my-1.5 tw-w-10" />
        </template>
      </base-table>
      <base-table :fields="fields" :items="payments" class="tw-mt-3" v-else>
        <template #created="{ item: payment}">
          {{ formatDate(payment.created) }}
        </template>
        <template #amount="{ item: payment}">
          {{ formatCurrency(payment.amount, payment.currency) }}
        </template>
        <template #status="{ item: payment }">
          <base-badge size="sm" :color="getBadgeColor(payment.status)">{{ capitalize(payment.status) }}</base-badge>
        </template>
        <template #empty-state>
          <div class="tw-flex tw-justify-center tw-text-gray-700 tw-py-4">
            No payments
          </div>
        </template>
      </base-table>
    </base-card>
    <business-payment-modal ref="businessPaymentModal" :business-id="businessId" :customer-id="stripeCustomerId" @new-payment="getPayments()" />
  </div>
</template>

<script>
import BusinessPaymentModal from "@/views/admin/components/BusinessPaymentModal";
import { PlusIcon } from "@/assets/svgs";
import moment from "moment";
import { capitalize } from "lodash";

export default {
  components: {
    BusinessPaymentModal,
    PlusIcon,
  },
  props: {
    businessId: String,
    stripeCustomerId: String,
  },
  data() {
    return {
      arePaymentsLoading: false,
      isProfileLoading: false,
      fields: [
        { title: "Date", key: "created" },
        { title: "Amount", key: "amount", thClass: "tw-text-right", align: "right" },
        { title: "Description", key: "description" },
        { title: "Status", key: "status", thClass: "tw-text-center", align: "center" },
        { title: "Email", key: "email" },
      ],
      payments: [],
      email: null,
    };
  },
  computed: {
    isLoading() {
      return this.arePaymentsLoading || this.isProfileLoading;
    },
  },
  created() {
    this.getPayments();
    this.getProfile();
  },
  methods: {
    capitalize,
    async getPayments() {
      if (!this.stripeCustomerId) return;
      try {
        this.arePaymentsLoading = true;
        const response = await this.$axios.get(`/businesses/${this.businessId}/customer/${this.stripeCustomerId}/charges`);
        this.payments = response.data.sort((a, b) => (a.created < b.created ? 1 : -1));
      } finally {
        this.arePaymentsLoading = false;
      }
    },
    async getProfile() {
      try {
        this.isProfileLoading = true;
        const response = await this.$axios.get(`/businesses/${this.businessId}/profile`);
        this.email = response.data.contacts ? response.data.contacts[0].email : null;
      } finally {
        this.isProfileLoading = false;
      }
    },
    formatCurrency(cents, currency) {
      return new Intl.NumberFormat(window.navigator.language, { style: "currency", currency: currency }).format(cents / 100);
    },
    formatDate(date) {
      return new moment.utc(date).local().format("M/D/YYYY h:mm a");
    },
    getBadgeColor(status) {
      switch (status) {
        case "succeeded":
          return "green";
      }
      return "primary";
    },
  },
  watch: {
    stripeCustomerId() {
      this.getPayments();
    },
  },
};
</script>
